import { getCropColor, getCropCssColor, getCropName, getFieldCroppingArea, isCropping, isFieldViewModel } from "../shared/fields";
import { checkPerennialSequence, getFieldHistory } from "../shared/fields/autohistory";
import { checkGrassCutsSupport, CroppingAttr, getGrowingSeasonLengthValues } from "../shared/fields/croppingAttr";
import { EditContext } from "../shared/fields/cropYear/editContext";
import { RowWithListColumns } from "../shared/fields/cropYear/RowWithListColumns";
import { Target } from "../shared/fields/cropYear/target";
import { TargetCategory } from "../shared/fields/cropYear/targetCategory";
import { TargetField } from "../shared/fields/cropYear/targetField";
import { checkDatesAndCroppingYear, checkNonPerennialDestructionDate, checkPerennialCroppingYear } from "../shared/fields/dates/dates";
import { DateValidationService } from "../shared/fields/dates/validation";
import { FieldViewModelImpl } from "../shared/fields/fieldViewModel";
import { createFilter } from "../shared/fields/filters/filters";
import { getConcurrentCrops, getCroppingDatesInYear, getCroppingSiblings, getStdFieldHistory } from "../shared/fields/history";
import { getCroppingFeatures, withCroppingSelection } from "../shared/fields/map/cropping";
import { FieldsMap } from "../shared/fields/map/fieldsMap";
import { FieldsMapContainerContext } from "../shared/fields/map/fieldsMapContext";
import { FieldsMapFactory } from "../shared/fields/map/fieldsMapFactory";
import { getCroppingFilter } from "../shared/fields/map/filter";
import { CroppingLayer } from "../shared/fields/map/layers/croppingLayer";
import { CroppingLayerStyle, getDefaultStrokeStyle } from "../shared/fields/map/layers/croppingStyle";
import { FieldsLayer } from "../shared/fields/map/layers/fieldsLayer";
import { createCropStylePattern, getOrCreateCropStylePattern } from "../shared/fields/map/patterns";
import { createCroppingStyleProvider } from "../shared/fields/styles";
import { Dates } from "../shared/fields/timeline/components/Dates";
import { SingleField } from "../shared/fields/timeline/components/Field";
import { changeYearRange, getDefaultScrollPosition, setupYears } from "../shared/fields/timeline/dates";
import { DomItem } from "../shared/fields/timeline/domItem";
import { createTimelineItems } from "../shared/fields/timeline/layout";
import { getInitialState } from "../shared/fields/timeline/state";
import { getDefaultViewConfig } from "../shared/fields/timeline/viewConfig";
import { viewState } from "../shared/fields/timeline/viewState";
import { getDatePosition } from "../shared/fields/timeline/vm";
import { FieldsMapLabels } from "../shared/fields/types";
import { watchFields } from "../shared/fields/watch";


export const cropYear = {
    EditContext,
    Target,
    TargetCategory,
    TargetField,
}

export const timeline = {
    DomItem,
    SingleField,
    getDatePosition,
    getDefaultScrollPosition,
    getInitialState,
    changeYearRange,
    setupYears,
    getDefaultViewConfig,
    createTimelineItems,
    viewState,
    Dates
}

export const map = {
    FieldsMap,
    FieldsMapFactory,
    FieldsMapContainerContext,

    createCropStylePattern,
    withCroppingSelection,
    getCroppingFilter,
    getCroppingFeatures,
    getOrCreateCropStylePattern,

    layers: {
        FieldsLayer,
        CroppingLayer,
        CroppingLayerStyle,
        getDefaultStrokeStyle
    }
}


export const fields = {

    FieldViewModelImpl,

    createFilter,

    CroppingAttr,

    DateValidationService,

    getFieldCroppingArea,
    getConcurrentCrops,
    getCropName,
    getCroppingDatesInYear,
    getCroppingSiblings,
    getCropColor,
    getCropCssColor,
    getFieldHistory,
    getStdFieldHistory,
    checkGrassCutsSupport,
    checkPerennialSequence,
    checkPerennialCroppingYear,
    checkDatesAndCroppingYear,
    checkNonPerennialDestructionDate,
    getGrowingSeasonLengthValues,

    isFieldViewModel,
    isCropping,

    watchFields,

    createCroppingStyleProvider,

    FieldsMapLabels,

    cropYear,
    timeline,
    map,

}

